import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { CompanyAccount, PagedResult } from '../../models';


export interface ICompanyAccountService {

	get(companyId: string, accountId: string): Promise<CompanyAccount>;
	list(companyId: string): Promise<CompanyAccount[]>;
	page(companyId: string, pageIndex: number, pageSize: number): Promise<PagedResult<CompanyAccount>>;
	save(model: CompanyAccount): Promise<CompanyAccount>;
	delete(companyId: string, accountId: string): Promise<any>;

}

@injectable()
export class CompanyAccountService implements ICompanyAccountService {


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}


	public get(companyId: string, accountId: string): Promise<CompanyAccount> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/accounts/${accountId}`;
		return this.httpClient.get<CompanyAccount>(url);
	}

	public list(companyId: string): Promise<CompanyAccount[]> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/accounts`;
		return this.httpClient.get<CompanyAccount[]>(url);
	}

	public page(companyId: string, pageIndex: number, pageSize: number): Promise<PagedResult<CompanyAccount>> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/accounts/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<CompanyAccount>>(url);
	}

	public save(model: CompanyAccount): Promise<CompanyAccount> {
		let url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${model.companyId}/accounts`;
		if (model.id !== null && model.id !== undefined && model.id !== '') {
			url += `/${model.id}`;
			return this.httpClient.put(url, model);
		}
		return this.httpClient.post(url, model);
	}

	public delete(companyId: string, accountId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.companyBaseUrl}/${companyId}/accounts/${accountId}`;
		return this.httpClient.delete(url);
	}

}
